import Column from '@sdk/components/ui/spacing/Column';
import Text14 from '@sdk/components/ui/typography/Text14';
import type {
  TimesheetHistoryItem,
  TimesheetHistoryTimeEntry,
} from '@sdk/timesheets/types/TimesheetHistory';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';

import AttestationsFromSingleProjection from '@web/timeClock/modals/rows/AttestationsRow/AttestationsFromSingleProjection';
import { Container } from '@web/timeClock/TimesheetHistoryActions/timesheetHistoryActions.styles';
import TimesheetHistoryRowsForDeletedEntry from '@web/timeClock/TimesheetHistoryRowsForDeletedEntry/TimesheetHistoryRowsForDeletedEntry';
import TimesheetHistoryRowsForAddedEntry from '@web/timeClock/TimesheetHistoryRowsForAddedEntry/TimesheetHistoryRowsForAddedEntry';
import TimesheetHistoryRowsForBreaksArray from '@web/timeClock/TimesheetHistoryRowsForBreaksArray/TimesheetHistoryRowsForBreaksArray';
import TimesheetHistoryRowsForClockInEdit from '@web/timeClock/TimesheetHistoryRowsForClockInEdit/TimesheetHistoryRowsForClockInEdit';
import TimesheetHistoryRowsForClockOutEdit from '@web/timeClock/TimesheetHistoryRowsForClockOutEdit/TimesheetHistoryRowsForClockOutEdit';
import TimesheetHistoryRowsForBreakEndsArray from '@web/timeClock/TimesheetHistoryRowsForBreakEndsArray/TimesheetHistoryRowsForBreakEndsArray';
import TimesheetHistoryRowsForAddedClockOutEntry from '@web/timeClock/TimesheetHistoryRowsForAddedEntry/TimesheetHistoryRowsForAddedClockOutEntry';

type Props = {
  historyItem: TimesheetHistoryItem;
};

const getEditedChanges = (editedChange: TimesheetHistoryTimeEntry) => {
  if (editedChange.clockInFrom && !editedChange.clockInTo) {
    return <TimesheetHistoryRowsForDeletedEntry editedChange={editedChange} />;
  }

  if (editedChange.clockInTo && !editedChange.clockInFrom) {
    return <TimesheetHistoryRowsForAddedEntry editedChange={editedChange} />;
  }

  if (editedChange.clockOutTo && !editedChange.clockOutFrom && !editedChange.clockInTo) {
    return <TimesheetHistoryRowsForAddedClockOutEntry editedChange={editedChange} />;
  }

  return (
    <>
      {Boolean(editedChange.breaks.length) && (
        <TimesheetHistoryRowsForBreaksArray editedChange={editedChange} />
      )}
      {Boolean(editedChange.clockInFrom && editedChange.clockInTo) && (
        <TimesheetHistoryRowsForClockInEdit editedChange={editedChange} />
      )}
      {Boolean(editedChange.clockOutFrom && editedChange.clockOutTo) && (
        <TimesheetHistoryRowsForClockOutEdit editedChange={editedChange} />
      )}
      {Boolean(editedChange.breakEnds.length) && (
        <TimesheetHistoryRowsForBreakEndsArray editedChange={editedChange} />
      )}
    </>
  );
};

const TimesheetHistoryAction = ({ historyItem }: Props) => {
  return (
    <Container>
      {Boolean(historyItem.editedChanges?.length) &&
        historyItem.editedChanges.map((editedChange, index) => {
          return (
            <Column mTop={index > 0 ? 5 : 0} key={index}>
              {getEditedChanges(editedChange)}
            </Column>
          );
        })}
      {Boolean(historyItem.timeclockChanges?.length) &&
        historyItem.timeclockChanges.map(
          ({ text, component, breakAttestations }, index: number) => (
            <Column mTop={index ? 0 : 5} key={index}>
              {Boolean(breakAttestations?.length) && (
                <Column mBottom={10}>
                  <AttestationsFromSingleProjection
                    withCaption={true}
                    breakAttestations={breakAttestations}
                  />
                </Column>
              )}
              {Boolean(text) && <Text14 themeColor={ThemeColorType.gray}>{text}</Text14>}
              {Boolean(component) && <Column>{component}</Column>}
            </Column>
          )
        )}
    </Container>
  );
};

export default TimesheetHistoryAction;
